/**
 * Coarse continent outlines as flat [lon, lat, lon, lat, …] lists.
 * Only used to shape the binary-digit world map behind the pages, so precision is
 * roughly one grid cell (2–4 degrees).
 */
export const land = [
  // North America
  [-168, 66, -162, 70, -156, 71.3, -140, 69.6, -128, 70, -115, 68.5, -95, 71.5, -82, 69, -80, 63,
    -94, 59, -88, 56, -82, 53, -78, 58, -77, 62, -70, 61, -64, 60, -60, 55, -56, 52, -66, 45, -70, 43,
    -74, 40, -76, 35, -81, 31, -80.5, 25.5, -82, 27, -84, 30, -89, 30, -94, 29.5, -97, 27, -97.5, 22,
    -95, 18.5, -91, 19, -90.5, 21, -87, 21.5, -88, 16, -84, 15.5, -83, 10.5, -79.5, 9, -77.5, 8,
    -80, 7.5, -83, 8.5, -86, 11, -88, 13.3, -92, 14.5, -96, 15.7, -105, 19.5, -106, 23, -110, 24,
    -112, 28, -114.5, 31, -117, 32.5, -120.5, 34.5, -124, 40, -124.5, 43, -124, 48.5, -127, 50.5,
    -130, 54, -134, 58, -140, 59.8, -147, 60.5, -152, 59, -158, 57, -164, 54.6, -158, 58.5, -162, 60,
    -165, 62.5, -164.5, 64.5],
  // Baffin Island
  [-90, 72, -80, 73.5, -70, 70.5, -62, 66.5, -65, 62.5, -73, 64, -78, 65, -85, 69.5],
  // Canadian Arctic archipelago
  [-125, 72, -115, 74, -100, 76, -90, 77, -80, 80, -65, 82.5, -85, 83, -100, 80.5, -115, 78, -122, 76],
  // Greenland
  [-73, 78, -60, 82, -35, 83.5, -20, 82, -18, 77, -21, 70, -28, 68, -35, 65.5, -42, 60, -48, 61,
    -53, 66, -55, 70, -60, 76],
  // Cuba, Hispaniola
  [-85, 21.9, -82, 23.2, -77.5, 22.3, -74.2, 20.2, -77.7, 19.9, -81, 21.6],
  [-74.5, 18.4, -72.8, 19.9, -69, 19.6, -68.4, 18.6, -71.5, 17.6],
  // South America
  [-80, 9, -77, 8.5, -75.5, 10.5, -72, 12, -67, 10.7, -62, 10.7, -60, 8.5, -57, 6, -52, 5, -50, 1.5,
    -48, -1, -44, -2.5, -38.5, -4, -35, -6, -35, -9, -37, -12, -39, -17, -40, -20.5, -42, -23, -46, -24,
    -48.5, -27, -49, -29, -51, -31.5, -53, -34, -55, -35, -57, -36.3, -57, -38.5, -62, -39, -65, -41,
    -64, -42.5, -65.5, -45, -67.5, -46.5, -66, -48, -69, -51, -68.5, -52.5, -70, -55, -72, -54,
    -75, -51, -75.5, -46, -73.5, -42, -73.5, -37, -71.5, -30, -70.5, -23, -70, -18.5, -75, -15,
    -77, -12, -79.5, -7.5, -81, -5, -80, -2, -80, 1, -78.5, 2.5, -77.5, 4, -77.5, 7],
  // Iceland, Great Britain, Ireland
  [-24, 65.5, -22, 66.4, -16, 66.5, -13.6, 65.1, -15, 64.3, -18.7, 63.4, -22.6, 63.8],
  [-5.7, 50.1, -3, 50.6, 1.4, 51.2, 1.7, 52.7, 0.2, 53.4, -1.6, 55.6, -2, 57.6, -4, 57.6, -3, 58.6,
    -5, 58.6, -6.2, 56.8, -5.5, 55.5, -4.8, 54.8, -3.2, 54.2, -3, 53.4, -4.5, 52.8, -5.2, 51.7, -3.4, 51.4],
  [-6, 52.2, -6.2, 53.8, -5.8, 55.2, -7.5, 55.3, -8.6, 54.3, -10, 54, -9.8, 52, -8.2, 51.7],
  // Eurasia
  [-9, 37, -9, 43, -1.5, 43.5, -1.2, 46, -4.5, 48, -1.5, 49.7, 1.5, 51, 4, 51.5, 5, 53.3, 8.5, 54,
    8.3, 55.5, 8, 57, 10.5, 57.7, 10.5, 56, 12.5, 55.5, 11, 54, 14, 54, 18, 54.8, 21, 55.5, 21, 57,
    24, 57.5, 23.5, 59, 28, 59.5, 30, 60, 22.5, 60.2, 21.5, 61.5, 21.5, 63, 25, 65, 22.5, 65.8,
    19, 63.5, 17.5, 61, 19, 60, 18, 59, 16.5, 57, 14.5, 56, 13, 55.5, 11, 58.5, 8, 58, 5.5, 58.5,
    5, 61, 5.5, 62.5, 8.5, 63.5, 12, 65.5, 14, 67.5, 16, 69, 19, 70, 23, 70.8, 26, 71, 29, 70.6,
    31, 70, 33, 69.3, 36, 69, 41, 67.5, 38, 66, 34, 66.2, 33, 64.5, 37, 63.8, 40.5, 64.5, 44, 66.2,
    44, 68.5, 46, 68, 53, 68.5, 58, 68.8, 66, 69.5, 68, 72.5, 72, 72.8, 73, 68.5, 75, 72.5, 80, 73.5,
    87, 74.5, 98, 76.3, 105, 77.6, 113, 76, 113, 73.5, 120, 73, 130, 71, 140, 72.5, 150, 71.5,
    160, 70, 170, 70, 180, 69, 180, 65, 179, 62.5, 173, 61, 170, 60, 163, 59.8, 163, 57, 156, 51,
    156, 57, 160, 61, 155, 59.3, 148, 59.3, 142, 59, 137, 54, 141, 52.5, 140, 48, 133, 43,
    129.7, 41, 129.5, 37, 126.5, 34.5, 126, 37.5, 124.8, 39.5, 121.5, 38.8, 121, 40.8, 118, 39,
    119.5, 37, 122.5, 37, 119, 34.5, 121, 32, 122, 30, 119.5, 26, 117, 23.5, 113.5, 22.2, 110.5, 21,
    109, 21.6, 106.5, 20.2, 105.7, 18.5, 108.8, 15.5, 109.2, 11.7, 105, 8.6, 104.8, 10.5, 103, 10.7,
    100.5, 13.6, 99.2, 10, 100.5, 7.2, 103.3, 4, 103.4, 1.4, 101, 2.7, 98.3, 7.8, 98.5, 13, 97.6, 16.5,
    94.3, 16, 94.2, 19, 92.3, 20.8, 90.5, 22.5, 88, 21.7, 86.9, 20.8, 85, 19.5, 82.3, 16.6, 80.2, 13.5,
    80.3, 10, 78.2, 8.4, 76.6, 8.9, 74.8, 12.8, 73.3, 17, 72.6, 21.4, 70.2, 22.5, 68.5, 23.5,
    66.7, 25.4, 61.5, 25.2, 57.3, 25.8, 56.4, 27, 54.4, 26.7, 51.3, 27.9, 50, 30.1, 48.3, 29.8,
    48.6, 28.1, 50.2, 26.3, 51.6, 25, 52, 24, 54.1, 24.1, 56.3, 25.9, 56.4, 24.6, 57.8, 23.7,
    59.8, 22.4, 58.5, 20.4, 57.4, 18.9, 55.2, 17.3, 52.2, 15.6, 48.7, 13.9, 45, 12.8, 43.3, 12.8,
    42.6, 15.5, 41.2, 18.5, 39.1, 21.8, 38.4, 23.7, 36.6, 25.8, 35, 28.1, 34.5, 29.5, 34.2, 31.3,
    35, 33, 36, 35, 36.1, 36.8, 32.5, 36.1, 30.4, 36.3, 28, 36.7, 27, 37.5, 26.5, 39, 26.2, 40.2,
    24, 40.8, 23, 39.5, 23.2, 38, 22, 36.5, 21.2, 37.8, 21, 39.5, 19.5, 41.8, 19, 42.5, 16, 43.5,
    13.7, 45.6, 12.3, 45.2, 13.5, 43.6, 16, 41.9, 18.5, 40.2, 16.5, 38.8, 15.7, 38, 15.5, 40,
    12.5, 41.8, 10.5, 43, 8.8, 44.4, 7.5, 43.8, 5, 43.4, 3.2, 43, 3.2, 41.9, 0.8, 41, -0.3, 39.5,
    0.2, 38.8, -0.7, 37.6, -2.1, 36.7, -4.4, 36.7, -5.6, 36, -6.3, 36.8, -7.4, 37.2],
  // Africa and Madagascar
  [-17, 21, -16, 24, -14.5, 26, -13, 27.7, -9.8, 29.8, -9.5, 32.5, -6.8, 34, -5.9, 35.8, -2, 35.1,
    1, 36.5, 5, 36.8, 8.5, 37, 10, 37.3, 11.1, 36.9, 10.2, 34.5, 11, 33.2, 13, 32.8, 15.3, 32.2,
    18.5, 30.4, 20, 31, 20, 32.2, 23, 32.6, 25, 31.6, 29, 30.9, 32.3, 31.3, 34.2, 31.3, 34.5, 29.5,
    33.8, 27.6, 35.5, 24, 37.2, 21, 38.5, 18, 39.7, 15.5, 41.2, 14, 43.3, 12.5, 43.2, 11.5, 45, 10.4,
    51.2, 11.8, 51, 10.4, 49.5, 6.8, 47.8, 4.2, 44, 1, 41.5, -1.7, 40, -3.3, 39.2, -4.7, 39.3, -7,
    39.6, -10, 40.5, -11, 40.5, -15, 37, -17.5, 35, -20, 35.5, -23.5, 33, -25.5, 32.8, -28, 31, -29.9,
    28, -32.5, 25.6, -34, 22.5, -34, 20, -34.8, 18.4, -34, 18, -32, 17, -28.5, 15, -26.8, 14.5, -22,
    11.8, -17.5, 12, -14, 13.6, -11.5, 13, -9, 12.2, -6, 11.8, -3.8, 9.2, -1, 9.6, 1, 9.8, 3.2,
    8.5, 4.6, 6.5, 4.3, 4.5, 6.2, 2, 6.3, -2, 4.8, -4, 5.2, -7.5, 4.4, -9, 5, -11.4, 6.8, -13, 8,
    -13.3, 9.8, -15, 11, -16.7, 12.4, -17.2, 14.6, -16.5, 16.2, -16.1, 18.5],
  [49.3, -12, 50.5, -15.5, 49.4, -17.8, 47.5, -24.8, 45.2, -25.5, 43.7, -22.5, 44, -20, 44.3, -16.5, 47.8, -13.6],
  // Arctic islands
  [52, 71.5, 56, 74, 62, 76.5, 68, 76.8, 58, 73, 55, 71],
  [11, 78.5, 16, 80, 23, 80.3, 27, 79, 20, 77.5, 16, 76.6],
  // East and South-East Asia islands
  [130, 31, 131.5, 31.5, 132, 33.8, 135, 34, 137, 34.5, 140, 35, 141, 38, 142, 40, 141.5, 41.4,
    140, 40.5, 139.8, 38.5, 137, 37, 133, 35.5, 130.5, 34.2],
  [140, 41.5, 141.5, 42.5, 143.3, 42, 145.5, 43.3, 142, 45.4, 141.6, 44],
  [142, 46, 143.5, 49, 143, 54, 142.2, 54.3, 142, 50],
  [120, 22, 121.9, 25, 121, 25.2, 120.1, 23.3],
  [79.8, 6, 80.1, 9.8, 81.9, 7.5, 81.3, 6.2],
  [120, 18.5, 122.3, 18.5, 122, 16, 124, 13, 126.5, 7, 125.5, 6, 122, 7, 120.5, 10, 119.8, 13, 120.5, 15],
  [109, 1.5, 110, -1.5, 111, -3, 114.5, -3.8, 116.5, -2.5, 118, 1, 119, 5, 117, 7, 115.5, 5, 113, 3.2, 111, 1.5],
  [95.3, 5.5, 97.5, 5.2, 100.4, 2.2, 104, -1, 106, -3, 106, -5.8, 104.5, -5.9, 102.3, -4, 100.8, -1.8,
    98.8, 1.7, 96.3, 3.5],
  [105.2, -6.8, 106.5, -6, 110.5, -6.9, 114.5, -7.8, 114.5, -8.7, 110, -8.2, 106.5, -7.5],
  [119.5, -5.5, 120.5, -2.5, 120.8, 1.3, 124.8, 1.5, 121.5, -0.8, 123.3, -4.8, 121.8, -4.8, 120.4, -5.6],
  [131, -1, 134, -0.8, 137, -1.5, 141, -2.6, 145.8, -4.8, 147.5, -6, 150.5, -10.5, 147, -10, 143.5, -9,
    141, -9.2, 138.7, -8.3, 137.8, -5.4, 134.2, -4, 132, -2.9],
  // Oceania
  [113.4, -22, 114, -26, 115, -30, 115, -34, 117.8, -35.1, 122, -33.9, 126, -32.3, 131, -31.5,
    134.2, -32.8, 135.9, -34.8, 137.8, -32.7, 138.2, -35.6, 140, -37.7, 143.5, -38.8, 146.3, -39.1,
    150, -37.5, 151.5, -33, 153.5, -28, 153, -25, 150.8, -22.6, 149, -20.5, 146.3, -18.9, 145.3, -15,
    143.6, -14, 142.5, -10.7, 141.5, -13.6, 141.5, -17, 140, -17.7, 137, -15.9, 135.5, -15,
    136.9, -12.3, 132.6, -11.5, 131, -12.2, 129.5, -14.9, 127.5, -14.1, 125.2, -14.5, 122.9, -16.4,
    121, -19.5, 117, -20.6, 114.5, -21.8],
  [144.6, -40.7, 148.3, -40.9, 148, -43.2, 146, -43.6, 144.7, -41.8],
  [172.6, -34.4, 174.6, -36, 176, -37.6, 178.5, -37.7, 177, -39.3, 176.2, -41.2, 174.6, -41.3,
    175, -39.8, 173.8, -39.2, 174.4, -37.3],
  [172.7, -40.5, 174.3, -41.7, 173, -43.5, 171.2, -44.5, 170.6, -45.9, 169, -46.6, 166.5, -46,
    166.7, -45, 168.3, -44, 170.6, -42.9, 172, -41],
  // Antarctica
  [-180, -66, 180, -66, 180, -90, -180, -90],
];

export const water = [
  // Black Sea
  [28, 41.3, 28.5, 43.5, 30, 45.5, 33.5, 44.5, 36.5, 45.3, 38, 47, 39.5, 47, 41.5, 42, 36, 41.7, 33, 42],
  // Caspian Sea
  [47, 44.5, 50, 46.5, 53, 47, 53, 45, 51, 44.5, 53, 41, 54, 38, 53.5, 36.8, 51, 36.8, 49, 38, 49.5, 40.5, 47.5, 42.5],
];
